interface PopupPayload {
  title: string;
  text: string;
}

interface State {
  fixBody: boolean;
  showCatalogMenu: boolean;
  globalLoader: boolean;
  showFilter: boolean;
  openMenu: boolean;
  openSecondMenu: boolean;
  openFirstMenu: boolean;
  breadcrumbsList: any[] | null;
  propsSecondMenu: Record<string, unknown> | null;
  popup: PopupPayload;
  popupTextShow: boolean;
}

const state: State = {
  globalLoader: false,
  fixBody: false,
  openMenu: true,
  openSecondMenu: false,
  openFirstMenu: false,
  breadcrumbsList: null,
  propsSecondMenu: null,
  showFilter: true,
  showCatalogMenu: false,
  popup: {
    title: "",
    text: "",
  },
  popupTextShow: false,
};

const getters = {
  globalLoader: (state: State) => state.globalLoader,
  popup: (state: State) => state.popup,
};

const mutations = {
  SHOW_GLOBAL_LOADER(state: State, status: boolean): void {
    state.globalLoader = status;
  },
  FIX_BODY(state: State, param: boolean): void {
    const body = document.querySelector("body");
    if (!body) return;
    body.classList[param ? "add" : "remove"]("fix");
    state.fixBody = param;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
